import * as React from 'react';

import { Radio, RadioGroup } from '@coursera/cds-core';

import type { UseCurriculum_EstimatedAcademicTermFragment as EstimatedAcademicTerm } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';

import _t from 'i18n!nls/degree-home';

type Props = {
  termAvailability: EstimatedAcademicTerm[];
  selectedTerm: string;
  onTermSelected: (termId: string) => void;
};
const TermRadioGroup: React.FC<Props> = ({ termAvailability, selectedTerm, onTermSelected }) => {
  const title = _t('In which academic term would you like to plan the course?');
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onTermSelected(value === selectedTerm ? '' : value);
  };

  return (
    <RadioGroup label={title} name="term-selection" onChange={handleRadioChange} value={selectedTerm}>
      {termAvailability.map((term) => (
        <Radio
          key={term.estimatedTermId}
          label={term.estimatedTermName}
          value={term.estimatedTermId}
          checked={selectedTerm === term.estimatedTermId}
        />
      ))}
    </RadioGroup>
  );
};

export default TermRadioGroup;
